import { ViewProps } from './fill-in-blanks.constants';
import SubActivityView from '../sub-activity/sub-activity-view';
import ComponentOverlay from '../shared/component-overlay/component-overlay';
import { getSubActivityInstructionAsText } from '../sub-activity/sub-activity.utils';
import { useTeacherGetAnswers } from 'approot/activity-builder/present/activity-answers.hooks';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { useActivityBuilderFlags } from 'approot/activity-builder/activity-builder-flags';
import { getActiveStudentAnswerCount } from '../response/response.utils';
import { ComponentOverlayWrapper } from '../shared/component-overlay/component-overlay.style';
import FillInBlanksClassAnswers from './teacher/fill-in-blanks-class-answers';
import FillInBlanksViewAnswers from './fill-in-blanks-view-answers';
import { getComponentSelectorId } from '../shared/logic/get-component-selector-id';

const FillInBlanksView = (props: ViewProps) => {
  const { id, subActivityProperties } = props;

  const { isVisible, openModal, closeModal } = useSimpleModalState();

  const { activityBuilderRespondFlag } = useActivityBuilderFlags();
  const { componentAnswers, hasFetchedAnswers, error } = useTeacherGetAnswers({
    componentId: id,
    skip: !activityBuilderRespondFlag,
  });
  return (
    <SubActivityView subActivityDetails={props.subActivityProperties}>
      {isVisible && (
        <FillInBlanksClassAnswers {...props} onClose={closeModal} />
      )}
      <ComponentOverlayWrapper>
        <div id={getComponentSelectorId(id)}>
          <FillInBlanksViewAnswers {...props} fieldAnswers={componentAnswers} />
        </div>
        <ComponentOverlay
          ariaLabel={`View Fill in the Blanks activity for: ${getSubActivityInstructionAsText(
            subActivityProperties?.instructions
          )}`}
          componentId={id}
          hasFetchedAnswers={hasFetchedAnswers}
          error={error}
          getActiveStudentAnswerCount={answers =>
            getActiveStudentAnswerCount(answers)
          }
          onClick={openModal}
        />
      </ComponentOverlayWrapper>
    </SubActivityView>
  );
};

export default FillInBlanksView;
